import { differenceInMinutes } from "date-fns"

type DurationDateInput = Date | string | null | undefined

export function formatDuration(start: DurationDateInput, end: DurationDateInput): string | null {
  if (!start || !end) {
    return null
  }

  const startDate = start instanceof Date ? start : new Date(start)
  const endDate = end instanceof Date ? end : new Date(end)

  if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) {
    return null
  }

  const totalMinutes = differenceInMinutes(endDate, startDate)
  if (totalMinutes < 0) {
    return null
  }

  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60

  return `${hours}h ${minutes}m`
}
